import {Client} from '../../../graphql/types'

const IB_ID = [
  10078,
  10169,
  10162,
  10083,
  10096,
  10029,
  10093,
  10088,
  10084,
  10085,
  10230,
  10188,
  10227,
  10206,
  10227,
  10183,
  10235,
  10249,
  10237,
  10236,
  10244,
  10268,
  10212,
  10270,
  10248,
  10238,
  10209,
  10274,
  10213,
  10272,
  10276,
  10275,
  10279,
  10289,
  10226,
  10281,
  10291,
  10292,
  10293,
  10296,
  10300,
  10301,
  10302,
  10097,
  10305,
  10307,
  10295,
  10318,
  10297,
  10246,
  10322,
  10224,
  10320,
  10222,
  10329,
  10303,
  10316,
  10324,
  10358,
  10346,
  10333,
  10338,
  10332,
  10341,
  10342,
  10350,
  10354,
  10330,
  10327,
  10355,
  10326,
  10319,
  10361,
  10367,
  10319,
  10363,
  10371,
  10372,
  10167,
  10166,
  10376,
  10377,
  10365,
  10382,
  10389,
  10369,
  10381,
  10390,
  10391,
  10392,
  10364,
  10400,
  10401,
  10402,
  10404,
  10407,
  10408,
  10258,
  10409,
  10403,
  10416,
  10417,
  10418,
  10414,
  10430,
  10443,
  10438,
  10442,
  10427,
  10439,
  10458,
  10450,
  10451,
  10447,
  10446,
  10467,
  10456,
  10473,
  36993,
  10206,
  10236,
  10167,
  10367,
  10427,
  10166,
  10244,
  10453,
  37015,
]

export const overrideForIB = (accounts: any[], client: Client) => {
  if (!client.metadata) return accounts

  let metadata: any
  try {
    metadata = JSON.parse(client.metadata)
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (!IB_ID.includes(remoteIbId)) return accounts

  return accounts.filter(
    (account) =>
      !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype) &&
      account.category !== 'affiliate',
  )
}
